import { send } from 'server';

const SEND_CONFIG = {
    responsiblegamingbetlimits: {
        limitType: 'bet',
        fetch: {
            ID: 35634,
            responses: [35635, 35636],
            description: 'Get Player Bet Limits'
        },
        save: {
            ID: 35649,
            responses: [35650, 35651],
            description: 'Set Player Bet Limits'
        }
    },
    responsiblegaminglosslimits: {
        limitType: 'loss',
        fetch: {
            ID: 35643,
            responses: [35644, 35645],
            description: 'Get Player Loss Limits'
        },
        save: {
            ID: 35646,
            responses: [35647, 35648],
            description: 'Set Player Loss Limits'
        }
    },
    acceptPlayerRGLimits: {
        ID: 35799,
        responses: [35800, 35801],
        description: 'Accept Player RG Limits'
    }
};

export const fetchLimits = ({ type }) => send(SEND_CONFIG[type].fetch);

export const saveLimits = ({ type, limits, action }) => send({
    ...SEND_CONFIG[type].save,
    action,
    limits
});

export const getLimitType = type => SEND_CONFIG[type].limitType;

export const acceptLimits = ({ limitType, timePeriods }) => send({
    ...SEND_CONFIG.acceptPlayerRGLimits,
    action: 'accept',
    limitType,
    timePeriods
});

export const declineLimits = ({ limitType, timePeriods }) => send({
    ...SEND_CONFIG.acceptPlayerRGLimits,
    action: 'decline',
    limitType,
    timePeriods
});
